module.exports = __webpack_public_path__ + "static/media/Karan Acoustics Phono 2.23704ed4.jpg";